//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    listItems: Array,
    isHiddenMobile: {
      type: Boolean,
      default: false
    }
  }
}
